import Swiper from 'swiper/bundle';

jQuery(function ($) {
    if ($('.hero__slider').length == 0) {
        return;
    }

    let buttons = $('.hero .hero__slider-btn');
    let buttonProgress = $('.hero .hero__slider-btn-progress');

    // Initialize the Swiper instance
    const heroSlider = new Swiper('.hero__slider', {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        lazy: true,
        speed: 600,
        autoplay: {
            delay: 3000, 
            disableOnInteraction: false,
        },
    });

    let firstOne = true;

    // Synchronize progress bar with each slide change
    heroSlider.on('slideChange', function () {
        resetProgressBars();
        startProgressBar(heroSlider.realIndex);
    });

    // Add hover event to each button
    buttons.each(function (index) {
        $(this).on('mouseover', function () {
            heroSlider.slideToLoop(index);
            resetProgressBars();
            startProgressBar(index);

            heroSlider.autoplay.stop();
            heroSlider.autoplay.start();
        });
    });

    // Function to reset all progress bars
    function resetProgressBars() {
        buttonProgress.css({
            width: '0%',
            opacity: '0',
            transition: 'none', 
        });
    }

    // Function to start the progress bar animation for a specific index
    function startProgressBar(index) {
        let delay = heroSlider.params.autoplay.delay + 600;
        if (firstOne){delay -= 600; firstOne = false;}
        $(buttonProgress[index])
            .css({
                opacity: '1',
                transition: `width ${delay}ms linear`, 
            })
            .css('width', '100%');
    }
});
